import type { ScreenMonitor } from '@viewer/protocol';
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import type { ActiveSession, RemoteCursorListener } from '../../lib/session/controller';
import { monitorLabel } from './monitors';
import { RemoteScreen, type ScreenZoom } from './RemoteScreen';
import type { SendInput } from './remoteInput';
import styles from './ViewerScreen.module.css';

interface Props {
  popup: Window;
  index: number;
  monitor: ScreenMonitor;
  zoom: ScreenZoom;
  session: ActiveSession;
  sendInput: SendInput;
  watchRemoteCursor(listener: RemoteCursorListener): () => void;
  onAppPaste(): void;
  onBrowserPaste(data: DataTransfer): boolean;
  onReattach(): void;
}

/** Um monitor do computador remoto na própria janela, desenhada a partir da janela principal. */
export function DetachedMonitor({ popup, index, onReattach, ...screen }: Props) {
  const surfaceRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  return createPortal(
    <div className={styles.root}>
      <header className={styles.bar}>
        <div className={styles.left}>
          <span>{monitorLabel(index, screen.monitor)}</span>
          <span className={styles.peer}>{screen.session.info.peerName}</span>
        </div>
        <div className={styles.right}>
          <button
            type="button"
            className={styles.action}
            title="Fecha esta janela e devolve o monitor à janela principal"
            onClick={onReattach}
          >
            Reanexar
          </button>
        </div>
      </header>
      <RemoteScreen {...screen} surfaceRef={surfaceRef} videoRef={videoRef} />
    </div>,
    popup.document.body,
  );
}
